import {
  createSchemaConfig,
  buildTimeIntervalDimensionsConfig,
  buildTimeIntervalDimensionsGrouping,
} from '../helpers/schema.helpers'
import {
  InsightsFormatterType,
  InsightsGroupByTypes,
  InsightsMetricDesiredDirection,
} from '../types/schema.types'
import { Metrics, Dimensions } from './insightsPortalCancelledOrders.types'

export { Metrics, Dimensions }

export const schemaConfig = createSchemaConfig({
  metrics: Metrics,
  dimensions: Dimensions,

  metricsConfig: {
    [Metrics.COUNT_CANCELLATIONS]: {
      formatter: InsightsFormatterType.Integer,
      label: 'insightsPortalDomain.performanceDashboard.metrics.COUNT_ORDER',
    },
  },

  dimensionsConfig: {
    [Dimensions.INSIGHTS_PORTAL_ORDER_SOURCE]: {
      type: InsightsGroupByTypes.Program,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.insightsPortalOrderSource',
    },
    [Dimensions.PLATFORM]: {
      type: InsightsGroupByTypes.Program,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.platform',
      private: true,
    },
    [Dimensions.INSIGHTS_PORTAL_REPORTING_PLATFORM]: {
      type: InsightsGroupByTypes.Program,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.insightsPortalReportingPlatform',
      private: true,
    },
    [Dimensions.WAREHOUSE_LOCATION_GROUP]: {
      type: InsightsGroupByTypes.Info,
      magnitude: 5,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.warehouseLocationGroup',
    },
    [Dimensions.WAREHOUSE]: {
      type: InsightsGroupByTypes.Info,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.warehouse',
    },
    [Dimensions.WAREHOUSE_LOCATION_CODE]: {
      type: InsightsGroupByTypes.Info,
      magnitude: 5,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.warehouseLocationCode',
    },
    [Dimensions.ALCOHOL]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.alcohol',
    },
    [Dimensions.EXPRESS]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.express',
    },
    [Dimensions.LOYALTY]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.loyalty',
    },
    [Dimensions.EBT]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.ebt',
    },
    [Dimensions.FIRST_ORDER]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.firstOrder',
    },
    [Dimensions.VIRTUAL_WAREHOUSE]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.virtualWarehouse',
    },
    [Dimensions.WAREHOUSE_LOCATION]: {
      type: InsightsGroupByTypes.Info,
      magnitude: 5,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.warehouseLocation',
    },
    [Dimensions.WAREHOUSE_LOCATION_STATE]: {
      type: InsightsGroupByTypes.Info,
      magnitude: 2,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.warehouseLocationState',
    },
    [Dimensions.PARTNER_GEO_DIVISION]: {
      type: InsightsGroupByTypes.Program,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.partnerGeoDivision',
    },
    [Dimensions.ORDER_CURRENCY]: {
      type: InsightsGroupByTypes.Entity,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.orderCurrency',
    },
    [Dimensions.REGION]: {
      type: InsightsGroupByTypes.Info,
      magnitude: 4,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.region',
    },
    [Dimensions.FULFILLMENT_TYPE]: {
      type: InsightsGroupByTypes.Program,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.fulfillmentType',
    },
    [Dimensions.FSA_HSA_ORDER]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.fsaHsaOrder',
    },
    [Dimensions.RX_ORDER]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.rxOrder',
    },
    [Dimensions.CANCELLED_ORDER_ID]: {
      type: InsightsGroupByTypes.Info,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.cancelledOrderId',
    },
    [Dimensions.DELIVERY_CREATED_DATE_TIME_PT]: {
      type: InsightsGroupByTypes.Info,
      formatter: InsightsFormatterType.Date,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.deliveryCreatedDateTimePt',
    },
    [Dimensions.DELIVERY_STATE]: {
      type: InsightsGroupByTypes.Info,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.deliveryState',
    },
    [Dimensions.CANCELLED_DATE_TIME_PT]: {
      type: InsightsGroupByTypes.Info,
      formatter: InsightsFormatterType.Date,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.cancelledDateTimePt',
    },
    [Dimensions.CANCELLATION_TYPE]: {
      type: InsightsGroupByTypes.Info,
      magnitude: 1,
      label: 'insightsPortalDomain.cancelledOrders.dimensions.cancellationType',
    },
    ...buildTimeIntervalDimensionsConfig,
  },

  dimensionGroupings: [
    buildTimeIntervalDimensionsGrouping,
    {
      label: 'insightsPortalDomain.filters.stores',
      dimensions: [
        Dimensions.WAREHOUSE,
        Dimensions.WAREHOUSE_LOCATION_STATE,
        Dimensions.REGION,
        Dimensions.WAREHOUSE_LOCATION_GROUP,
        Dimensions.WAREHOUSE_LOCATION,
        Dimensions.WAREHOUSE_LOCATION_CODE,
        Dimensions.PARTNER_GEO_DIVISION,
      ],
    },
    {
      label: 'insightsPortalDomain.filters.orders',
      dimensions: [
        Dimensions.CANCELLED_ORDER_ID,
        Dimensions.INSIGHTS_PORTAL_ORDER_SOURCE,
        Dimensions.FULFILLMENT_TYPE,
        Dimensions.ALCOHOL,
        Dimensions.VIRTUAL_WAREHOUSE,
        Dimensions.EXPRESS,
        Dimensions.LOYALTY,
        Dimensions.EBT,
        Dimensions.FSA_HSA_ORDER,
        Dimensions.RX_ORDER,
        Dimensions.FIRST_ORDER,
        Dimensions.ORDER_CURRENCY,
        Dimensions.CANCELLED_ORDER_ID,
      ],
    },
    {
      label: 'insightsPortalDomain.filters.deliveryState.label',
      dimensions: [
        Dimensions.CANCELLATION_TYPE,
        Dimensions.CANCELLED_DATE_TIME_PT,
        Dimensions.DELIVERY_CREATED_DATE_TIME_PT,
        Dimensions.DELIVERY_STATE,
      ],
    },
  ],
})
